import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export const FullScreenLoader = () => (
  <div className="flex min-h-screen items-center justify-center" data-testid="app-loading">
    <Loader2 className="h-6 w-6 animate-spin text-primary" />
  </div>
);

export function ProtectedRoute({ mode, children }) {
  const { user } = useAuth();
  if (user === null) return <FullScreenLoader />;
  if (!user) return <Navigate to="/login" replace />;
  if (mode && !user.modes?.includes(mode)) return <Navigate to="/ride" replace />;
  return children;
}
